import type { FC } from 'react';
import { isEmptyObject } from '../common-functions';
import HfCheckboxGroup from '../fields/checkbox-group/hf-checkbox-group.component';
import HfCheckbox from '../fields/checkbox/hf-checkbox.component';
import HfDateCompetency from '../fields/date-time/hf-date-competency.component';
import HfDateTime from '../fields/date-time/hf-date-time.component';
import HfTimeField from '../fields/date-time/hf-time-field.component';
import HfGeolocation from '../fields/geolocation/hf-geolocation.component';
import HfGrandScore from '../fields/grand-score/hf-grand-score.component';
import HfHistoryField from '../fields/history-field/hf-history-field.component';
import HfInput from '../fields/input/hf-input.component';
import HfRadioGroup from '../fields/radio-group/hf-radio-group.component';
import HfRichTextArea from '../fields/rich-text-area/hf-rich-text-area.component';
import HfSignature from '../fields/signature/hf-signature.component';
import HfTextArea from '../fields/text-area/hf-text-area.component';
import HfTwinColumnSelect from '../fields/twin-column-select/hf-twin-column-select.component';
import DataLabel from '../labels/data-label';
import type { DynamicFormFieldType, IDynamicFieldService } from './dynamic-form.interfaces';
import HfOptionBuilder from '../fields/option-builder/hf-option-builder.component';
import HfIconSelectorField from '../fields/icon-selector/hf-icon-selector-field.component';

export class DynamicFieldService implements IDynamicFieldService {
  private static instance: DynamicFieldService;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private finalFieldConfig: Record<string, FC<any>> = {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private constructor(overrideFieldConfig: Record<string, FC<any>> = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultFieldControlConfig: Record<string, FC<any>> = {
      LABEL: DataLabel,
      TEXTFIELD: HfInput,
      TEXTAREA: HfTextArea,
      RICHTEXTAREA: HfRichTextArea,
      CHECKBOX: HfCheckbox,
      DATEFIELD: HfDateTime,
      DATEFIELD_COMPETENCY: HfDateCompetency,
      TIMEFIELD: HfTimeField,
      OPTIONGROUP: HfRadioGroup,
      INTFIELD: HfInput,
      DOUBLEFIELD: HfInput,
      HISTORY: HfHistoryField,
      SIGNATURECAPTURE: HfSignature,
      MULTISELECTCHECKBOX: HfCheckboxGroup,
      GRAND_SCORE: HfGrandScore,
      TWIN_COLUMN_SELECT: HfTwinColumnSelect,
      GEOLOCATION: HfGeolocation,
      OPTION_BUILDER: HfOptionBuilder,
      ICON_SELECTOR: HfIconSelectorField,
    };

    this.finalFieldConfig = {
      ...defaultFieldControlConfig,
      ...overrideFieldConfig,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static getServiceInstance(overrideFieldConfig: Record<string, FC<any>> = {}) {
    if (!this.instance) {
      this.instance = new DynamicFieldService(overrideFieldConfig);
    } else if (!isEmptyObject(overrideFieldConfig)) {
      this.instance.overrideFieldConfig(overrideFieldConfig);
    }

    return this.instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public overrideFieldConfig(fieldConfig: Record<string, FC<any>>) {
    this.finalFieldConfig = {
      ...this.finalFieldConfig,
      ...fieldConfig,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldComponent(fieldType: DynamicFormFieldType, customFieldType?: string): FC<any> | undefined {
    if (fieldType !== 'CUSTOM') {
      return this.finalFieldConfig[fieldType];
    } else if (fieldType === 'CUSTOM' && customFieldType !== undefined) {
      return this.finalFieldConfig[customFieldType];
    }
  }
}
